import { html } from "../../../../../jb-nexus/node_modules/lit";
import { NexusComponent } from "./nexus.component";

export class LanguageSwitcher extends NexusComponent {
  supportedLanguages = ["en", "nl"];

  get languageElements() {
    return this.querySelectorAll(".language-switcher-lang");
  }

  get activeLanguageElement() {
    return Array.from(this.languageElements).find(el => 
      el.dataset.lang === this.activeLanguageCode
    );
  }

  get languageCodeFromURL() {
    const langPattern = this.supportedLanguages.join("|");
    const match = window.location.pathname.match(new RegExp(`^\\/(${langPattern})(\\/|$)`));
    return match?.[1] || null;
  }

  get activeLanguageCode() {
    if (this.languageCodeFromURL) return this.languageCodeFromURL;
    
    const lang = document.documentElement.lang.split("-")[0];
    return this.supportedLanguages.includes(lang) ? lang : "en";
  }

  get siteDefaultLanguage() {
    const currentLang = document.documentElement.lang.split("-")[0];
    
    return this.languageCodeFromURL 
      ? this.supportedLanguages.find(lang => lang !== currentLang) || "en"
      : this.supportedLanguages.includes(currentLang) ? currentLang : "en";
  }

  connectedCallback() {
    super.connectedCallback();
    this.activeLanguageElement?.classList.add("fw-bold");
    this.addEventListener("click", this.handleLanguageSwitch);
  }

  handleLanguageSwitch = (event) => {
    event.preventDefault();
    window.location.href = this.getNewUrl();
  }

  getNewUrl() {
    const segments = window.location.pathname.split("/").filter(Boolean);
    const urlLang = this.supportedLanguages.includes(segments[0]) ? segments[0] : null;
    const pathWithoutLang = "/" + (urlLang ? segments.slice(1) : segments).join("/");
    
    const currentLanguage = urlLang || this.siteDefaultLanguage;
    const otherLang = this.supportedLanguages.find(lang => lang !== currentLanguage);

    return otherLang === this.siteDefaultLanguage 
      ? pathWithoutLang
      : `/${otherLang}${pathWithoutLang === "/" ? "" : pathWithoutLang}`;
  }

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define("language-switcher", LanguageSwitcher);